export default __webpack_public_path__ + "static/media/sponsor-lgbt.61d251c7.png";